export const IBS_FETCH = 'IBS_FETCH';
export const IBS_FETCH_ALL = 'IBS_FETCH_ALL';
export const IBS_IS_FETCING = 'IBS_IS_FETCHING';
export const IBS_API = 'ibs';
export const IB_EDIT = 'IB_EDIT';
export const IB_SAVE = 'IB_SAVE';
export const IB_FILTER = 'IB_FILTER';


// WEBPACK FOOTER //
// ./src/constants/ibs.js